module.exports = __webpack_public_path__ + "static/media/cve_logo_text_color.cdcbf53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cve_logo_text_color.png
// module id = 1705
// module chunks = 0